import { Check, Clock, CreditCard, Package, Sparkles, Truck, X } from "lucide-react";

const STATUS_META = {
  created:           { label: "Čeká na prádelnu",    color: "bg-amber-100 text-amber-800",       icon: Clock },
  awaiting_payment:  { label: "Čeká na platbu",      color: "bg-orange-100 text-orange-800",     icon: CreditCard },
  accepted:          { label: "Přijato",             color: "bg-sky-100 text-sky-800",           icon: Check },
  picked_up:         { label: "Vyzvednuto",          color: "bg-indigo-100 text-indigo-800",     icon: Package },
  processing:        { label: "Pereme",              color: "bg-violet-100 text-violet-800",     icon: Sparkles },
  delivered:         { label: "Doručeno",            color: "bg-teal-100 text-teal-800",         icon: Truck },
  completed:         { label: "Dokončeno",           color: "bg-emerald-100 text-emerald-800",   icon: Check },
  cancelled:         { label: "Zrušeno",             color: "bg-rose-100 text-rose-700",         icon: X },
};

export const StatusBadge = ({ status, className = "" }) => {
  const m = STATUS_META[status] || STATUS_META.created;
  const Icon = m.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${m.color} ${className}`}
      data-testid={`status-${status}`}
    >
      <Icon className="w-3 h-3" />
      {m.label}
    </span>
  );
};

export const STATUS_ORDER = ["created", "awaiting_payment", "accepted", "picked_up", "processing", "delivered", "completed"];
export { STATUS_META };
